import {
  VStack,
  Button,
  Text,
  Icon,
} from "@chakra-ui/react";
import { MdCheck } from "react-icons/md";
import { SortControlsProps } from "./types";

export default function SortControls({
  currentSort,
  sortOptions,
  onSortChange,
}: SortControlsProps) {
  return (
    <VStack
      spacing={0}
      bg="bg.control"
      borderRadius="md"
      p={2}
      align="stretch"
      minW="250px"
    >
      {sortOptions.map((option) => {
        const isActive = currentSort === option.value;
        return (
          <Button
            key={option.value}
            variant="ghost"
            justifyContent="space-between"
            onClick={() => onSortChange(option.value)}
            fontWeight={isActive ? "semibold" : "normal"}
            colorScheme={isActive ? "blue" : "gray"}
            size="sm"
          >
            <Text>{option.label}</Text>
            {isActive && <Icon as={MdCheck} />}
          </Button>
        );
      })}
    </VStack>
  );
}
